"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DemandType = void 0;
var DemandType;
(function (DemandType) {
    DemandType["SALES_ORDER"] = "sales-order";
    DemandType["JOB"] = "job";
})(DemandType = exports.DemandType || (exports.DemandType = {}));
//# sourceMappingURL=demand-type.enum.js.map